module.exports = __webpack_public_path__ + "img/cross_error.807e4a0c.svg";